import { inject, Injectable, Injector } from '@angular/core';
import { EntityService } from '../../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../../core/state/entity.state';
import { LearningSectionLayoutEntity } from '../learning-section-layout-entity';
import { LearningSectionEntityService } from '../../services/learning-section.entity.service';

export const STATE_NAME = 'learningSectionLayoutEntity';

export const LearningSectionLayoutEntityState: GenericEntityStateClass<LearningSectionLayoutEntity> =
  createEntityState<LearningSectionLayoutEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class LearningSectionLayoutEntityService extends EntityService<LearningSectionLayoutEntity> {
  private injector = inject(Injector);

  constructor() {
    super();
    this.resourceType = 'learning-section-layouts';
    this.stateClass = LearningSectionLayoutEntityState;

    this.registerLazyRelation(
      'learning-sections',
      () => this.injector.get(LearningSectionEntityService)
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (state: any) => {
      const slice = state[STATE_NAME];
      return this.stateClass.allByQuery(slice, { query });
    };
  }
}
